import { FunctionComponent } from "react";
import { Timeline } from "@kanda-libs/ks-design-library";
import CompanyRiskFlag from "components/company/CompanyRiskFlag";
import Profile from "components/shared/Profile";
import useCompanyRiskStatus from "./useCompanyRiskStatus";
import AddCompanyRiskStatusButton from "./AddCompanyRiskStatusButton";

const CompanyRiskStatus: FunctionComponent = function () {
  const { timelineItems, cid } = useCompanyRiskStatus();

  return (
    <Profile.Section title="Company risk status">
      <Profile.Property
        label="Risk flag"
        value={<CompanyRiskFlag id={cid} />}
      />
      <Profile.Property label="Risk timeline" />
      <Timeline flipped items={timelineItems} />
      <AddCompanyRiskStatusButton />
    </Profile.Section>
  );
};

export default CompanyRiskStatus;
